/* Gogo Language Texts

Table of Contents

01.General
02.User Login, Logout, Register
03.Menu
04.Dashboards
05.Pages
06.Applications
  06.01.Chat
  06.02.Survey
  06.03.Todo
07.UI
  07.01.Alerts
  07.02.Badges
  07.03.Buttons
  07.04.Cards
  07.05.Carousel
  07.06.Charts
  07.07.Collapse
  07.08.Dropdowns
  07.09.Editors
  07.10.Forms
  07.11.Form Components
  07.12.Icons
  07.13.Input Groups
  07.14.Jumbotron
  07.15.Modal
  07.16.Navigation
  07.17.Popover & Tooltip
  07.18.Sortable
  07.19.Maps
  07.20.Tables
*/

const deMessages = {
  /* 01.General */
  'general.copyright': 'Myma.ai © 2019 All Rights Reserved.',

  /* 02.User Login, Logout, Register */
  'user.login-title': 'Anmeldung',
  'user.register': 'Registrieren',
  'user.forgot-password': 'Passwort vergessen',
  'user.email': 'Email',
  'user.newpassword': 'Neues Passwort',
  'user.currentpassword': 'Jetziges Passwort',
  'user.newpasswordagain': 'Neues Passwort nochmal',
  'user.password': 'Passwort',
  'user.forgot-password-question': 'Vergessen Passwort?',
  'user.fullname': 'Vollständiger Name',
  'user.firstname': 'Vorname',
  'user.lastname': 'Nachname',
  'user.login-button': 'ANMELDUNG',
  'user.register-button': 'REGISTRIEREN',
  'user.reset-password-button': 'ZURÜCKSETZEN',
  'user.buy': 'KAUFEN',
  'user.username': 'Nutzername',

  /* 03.Menu */
  'menu.app': 'Heim',

  'menu.default': 'Ursprünglich',
  'menu.analytics': 'Analytik',
  'menu.ecommerce': 'E-Commerce',
  'menu.content': 'Inhalt',
  'menu.pages': 'Seiten',
  'menu.data-list': 'Datenliste',
  'menu.thumb-list': 'Daumenliste',
  'menu.image-list': 'Bildliste',
  'menu.details': 'Details',
  'menu.search': 'Suche',
  'menu.login': 'Anmelden',
  'menu.register': 'Registrieren',
  'menu.forgot-password': 'Passwort vergessen',
  'menu.error': 'Fehler',
  'menu.applications': 'Anwendungen',
  'menu.todo': 'To‑Do‑Liste',
  'menu.survey': 'Umfrage',
  'menu.chat': 'Chat',
  'menu.ui': 'UI',
  'menu.edit': 'Bearbeiten',
  'menu.alerts': 'Warnungen',
  'menu.badges': 'Abzeichen',
  'menu.buttons': 'Schaltflächen',
  'menu.cards': 'Karten',
  'menu.carousel': 'Karussell',
  'menu.charts': 'Diagramme',
  'menu.collapse': 'Einklappen',
  'menu.dropdowns': 'Dropdowns',
  'menu.editors': 'Editoren',
  'menu.form-layouts': 'Formularlayouts',
  'menu.form-components': 'Formularkomponenten',
  'menu.form-validations': 'Formularvalidierungen',
  'menu.icons': 'Symbole',
  'menu.input-groups': 'Eingabegruppen',
  'menu.jumbotron': 'Jumbotron',
  'menu.modal': 'Modal',
  'menu.navigation': 'Navigation',
  'menu.popover-tooltip': 'Popover & Tooltip',
  'menu.sortable': 'Sortierbar',
  'menu.tables': 'Tabellen',
  'menu.menu': 'Menü',
  'menu.subhidden': 'Unterversteckt',
  'menu.hidden': 'Versteckt',
  'menu.visible': 'Sichtbar',
  'menu.maps': 'Karten',
  'menu.landingpage': 'Landingpage',
  'menu.multipage-home': 'Mehrseitige Startseite',
  'menu.singlepage-home': 'Einseitige Startseite',
  'menu.about': 'Über',
  'menu.auth-login': 'Authentifizierungs‑Login',
  'menu.auth-register': 'Authentifizierungs‑Registrierung',
  'menu.blog': 'Blog',
  'menu.blog-detail': 'Blogdetails',
  'menu.careers': 'Karriere',
  'menu.confirmation': 'Bestätigung',
  'menu.contact': 'Kontakt',
  'menu.docs': 'Dokumente',
  'menu.features': 'Funktionen',
  'menu.prices': 'Preise',
  'menu.videos': 'Videos',
  'menu.mailing': 'Mailing',
  'menu.invoice': 'Rechnung',
  'menu.blank-page': 'Kommt bald…',
  'menu.types': 'Menütypen',
  'menu.levels': 'Menüstufen',
  'menu.third-level-1': 'Dritte Stufe 1',
  'menu.third-level-2': 'Dritte Stufe 2',
  'menu.third-level-3': 'Dritte Stufe 3',

  /* 04.Dashboards */
  'dashboards.update': 'Aktualisieren',
  'dashboards.save': 'Speichern',
  'dashboards.name': 'Name',
  'dashboards.button': 'Schaltfläche',
  'dashboards.visits': 'Besuche',
  'dashboards.checkAvailability': 'Verfügbarkeit oder Preise prüfen',
  'dashboards.details': 'Einzelheiten',
  'dashboards.pending-orders': 'Ausstehend Aufträge',
  'dashboards.completed-orders': 'Abgeschlossen Aufträge',
  'dashboards.refund-requests': 'Erstattung Anfragen',
  'dashboards.new-comments': 'Neue Kommentare',
  'dashboards.sales': 'Verkauf',
  'dashboards.orders': 'Aufträge',
  'dashboards.refunds': 'Rückerstattungen',
  'dashboards.recent-orders': 'Jüngste Aufträge',
  'dashboards.product-categories': 'Produkt Kategorien',
  'dashboards.cakes': 'Kuchen',
  'dashboards.tickets': 'Tickets',
  'dashboards.calendar': 'Kalender',
  'dashboards.best-sellers': 'Bestseller',
  'dashboards.per-session': 'Pro Sitzung',
  'dashboards.profile-status': 'Profile Status',
  'dashboards.payment-status': 'Zahlung Status',
  'dashboards.work-progress': 'Arbeit Fortschritt',
  'dashboards.tasks-completed': 'Aufgaben Abgeschlossen',
  'dashboards.payments-done': 'Zahlungen Fertig',
  'dashboards.order-stock': 'Befehl - Aktie',
  'dashboards.categories': 'Kategorien',
  'dashboards.quick-post': 'Schnell Post',
  'dashboards.title': 'Titel',
  'dashboards.content': 'Inhalt',
  'dashboards.ticket-count': 'Ticketanzahl',
  'dashboards.commonticketsubmission': 'Häufige Ticketeinreichungen',
  'dashboards.category': 'Kategorie',
  'dashboards.connect': 'Verbinden',
  'dashboards.save-and-publish': 'Speichern und Veröffentlichen',
  'dashboards.top-viewed-posts': 'Meistgesehene Beiträge',
  'dashboards.posts': 'Beiträge',
  'dashboards.pending-for-publish': 'Wartet auf Veröffentlichen',
  'dashboards.users': 'Benutzerin',
  'dashboards.on-approval-process': 'Beim Zulassungsverfahren',
  'dashboards.alerts': 'Warnungen',
  'dashboards.waiting-for-notice': 'Warten auf Benachrichtigung',
  'dashboards.files': 'Dateien',
  'dashboards.pending-for-print': 'Wartet auf drucken',
  'dashboards.logs': 'Protokolle',
  'dashboards.gogo': 'GOGO',
  'dashboards.magic-is-in-the-details': 'DIE MAGIE LIEGT IM DETAIL',
  'dashboards.yes-it-is-indeed': 'Ja, das ist es in der Tat!',
  'dashboards.advanced-search': 'Erweiterte Suche',
  'dashboards.toppings': 'Beläge',
  'dashboards.type': 'Typ',
  'dashboards.keyword': 'Stichwort',
  'dashboards.search': 'Suche',
  'dashboards.top-rated-items': 'Bestbewertete Artikel',
  'dashboards.country': 'Land',
  'dashboards.webVisitors': 'Website-Besucher',
  'dashboards.avatarClicks': 'Avatar-Klicks',
  'dashboards.wordCloud': 'Wortwolke',
  'dashboards.topic': 'Thema',
  'dashboards.roomsAvailability': 'Zimmer & Verfügbarkeit',
  'dashboards.startChat': 'Chat starten',
  'dashboards.restaurantsBars': 'Restaurants & Bars',
  'dashboards.groupBooking': 'Gruppenbuchung',
  'dashboards.promotions': 'Angebote',
  'dashboards.weedingevents': 'Hochzeit & Events',
  'dashboards.lostsomething': 'Etwas verloren',
  'dashboards.producttext': 'Produkttext',
  'dashboards.bookingroomnew': 'Neues Zimmer buchen',
  'dashboards.email': 'E-Mail',
  'dashboards.phone': 'Telefon',
  'dashboards.zipcode': 'Postleitzahl',
  'dashboards.marketingconsent': 'Marketing-Zustimmung',
  'dashboards.additionalinfo': 'Zusätzliche Info',
  'dashboards.viewallcontacts': 'Alle Kontakte anzeigen',
  'dashboards.current': 'Aktuell',
  'dashboards.last7days': 'Letzte 7 Tage',
  'dashboards.last30days': 'Letzte 30 Tage',
  'dashboards.thisweek': 'Diese Woche',
  'dashboards.thismonth': 'Diesen Monat',
  'dashboards.previousmonth': 'Letzter Monat',
  'dashboards.yeartodate': 'Jahr bis heute',
  'dashboards.lastyear': 'Letztes Jahr',
  'dashboards.all': 'Alle',
  'dashboards.standardOccupancy': 'Standardbelegung',
  'dashboards.max-occupancy': 'Maximale Belegung',
  'dashboards.numberOfThisType': 'Anzahl dieses Typs',
  'dashboards.displayOrder': 'Anzeigereihenfolge',
  'dashboards.provider': 'Anbieter',
  'dashboards.edit': 'Bearbeiten',
  'dashboards.delete': 'Löschen',
  'dashboards.addImages': 'Bilder hinzufügen',
  'dashboards.location_ip': 'Ungefährer Standort, ermittelt anhand der IP-Adresse',
  'dashboards.near': 'In der Nähe',
  'dashboards.referral': 'Vom Benutzer über diese Website verwiesen',
  'dashboards.calling_party': 'Anrufer (initiierende Partei)',
  'dashboards.called_party': 'Angerufene Partei',
  'dashboards.lastdial': 'Letzter Anruf',
  'dashboards.imagelink': 'Bildlink',
  'dashboards.changelog': 'Änderungsprotokoll',
  'dashboards.externalresources': 'Externe Ressourcen',
  'dashboards.webpage': 'Webseite',
  'dashboards.web-pages': 'Webseiten',
  'dashboards.published': 'Veröffentlicht',
  'dashboards.adddocument': 'Dokument hinzufügen',
  'dashboards.ready-to-publish': 'Bereit zur Veröffentlichung',
  'dashboards.draft': 'Entwurf',
  'dashboards.order-by': 'Sortieren nach',
  'dashboards.add-faq': 'FAQ hinzufügen',
  'dashboards.collections': 'Sammlungen',
  'dashboards.items': 'Artikel',
  'dashboards.rooms-availability': 'Zimmer & Verfügbarkeit',
  'dashboards.events-wedding-venues': 'Veranstaltungen & Hochzeitsorte',
  'dashboards.long-stay-enquiry': 'Anfrage für Langzeitaufenthalt',
  'dashboards.reservation-confirmation-request': 'Reservierungsbestätigung anfordern',
  'dashboards.modify-cancel-booking': 'Buchung ändern oder stornieren',
  'dashboards.left-something-behind': 'Etwas vergessen',
  'dashboards.invoice-copy': 'Rechnung / Beleg Kopie',
  'dashboards.sync': 'Synchronisieren',
  'dashboards.add-web-page': 'Webseite hinzufügen',
  'dashboards.sprint-title': 'Lernen Sie Sprint kennen, unsere bahnbrechende Automatisierung zur Trainingsbeschleunigung von KI‑Modellen um das 10‑fache.',
  'dashboards.sprint-description': 'Sprint arbeitet an Ihrer Seite – zur Entfesselung von Kreativität, Steigerung der Produktivität und drastischen Reduzierung der Zeit, die zum Trainieren des Digital Assistant benötigt wird.',
  'dashboards.sprint-feature': 'Die Sprint‑Funktion ist darauf ausgelegt, Wissen aus externen Quellen zu synchronisieren, was sowohl für die Initialeinrichtung als auch für kontinuierliche Datenaktualisierungen wertvoll ist. Wenn sie auf einem aktiven System ausgeführt wird, passt Sprint das Knowledge Hub basierend auf Ihren konfigurierten externen Quellen an, was sich direkt auf KI‑generierte Verhaltensweisen und Antworten auswirken kann. Für Hilfe bei der Sprint‑Einrichtung wenden Sie sich bitte an unser Support‑Team.',
  'dashboards.change-password': 'Passwort ändern',
  'dashboards.sign-out': 'Abmelden',
  'dashboards.privacy-policy': 'Datenschutzrichtlinie',
  'dashboards.help-center': 'Hilfezentrum',
  'dashboards.switch-account': 'Konto wechseln',
  'dashboards.business-settings': 'Geschäftseinstellungen',
  'dashboards.notifications-allowed': 'Benachrichtigungen erlaubt',
  'dashboards.dark-theme': 'Dunkler Modus',
  'dashboards.online': 'Online',
  'dashboards.offline': 'Offline',
  'dashboards.invoice-&-payments': 'Rechnungen & Zahlungen',
  'dashboards.upgrade-plan': 'Plan upgraden',
  'dashboards.add-room': 'Zimmer hinzufügen',
  'dashboards.room-type': 'Zimmertyp',
  'dashboards.room-name': 'Zimmername',
  'dashboards.how-many-guests': 'Wie viele Gäste können in diesem Zimmer übernachten?',
  'dashboards.number-of-rooms-this-type': 'Anzahl Zimmer (dieser Art)',
  'dashboards.number-of-bedrooms': 'Anzahl Schlafzimmer',
  'dashboards.number-of-livingrooms': 'Anzahl Wohnzimmer',
  'dashboards.minimum-adults': 'Mindestanzahl Erwachsene',
  'dashboards.maximum-adults': 'Höchstanzahl Erwachsene',
  'dashboards.maximum-children': 'Höchstanzahl Kinder',
  'dashboards.maximum-infants': 'Höchstanzahl Säuglinge',
  'dashboards.extra-beds-allowed': 'Zusatzbetten erlaubt',
  'dashboards.booking-engine-code': 'Buchungssystem-Code',
  'dashboards.room-size': 'Zimmergröße',
  'dashboards.balcony-area': 'Balkonbereich',
  'dashboards.unit': 'Einheit',
  'dashboard.whatsapp_message': 'Geben Sie hier Ihre Nachricht ein...',
  'dashboard.whatsapp_reply_window': 'Sie haben ein 24-Stunden-Fenster, um auf eine Kundennachricht bei WhatsApp Business zu antworten, beginnend mit der letzten Nachricht des Kunden. Wenn Sie innerhalb dieses 24-Stunden-Kundenservicefensters antworten, können Sie jede Art von Nachricht senden. Nach Ablauf der 24 Stunden können Sie nur noch vorab genehmigte Nachrichtenvorlagen senden, die das 24-Stunden-Fenster neu starten, sobald der Kunde antwortet.',
  'dashboards.square-meters': 'Quadratmeter',
  "dashboard.pick_quick_reply": "Wählen Sie eine Schnellantwort oder geben Sie Ihre Nachricht ein",
  "dashboard.hang_in_there": "Bitte bleiben Sie dran, während wir versuchen, Sie zu verbinden!",
  "dashboard.outbound_msg": "Zeitpunkt zum Senden der ausgehenden Nachricht",
  "dashboard.message_sent": "Ihre Nachricht wurde erfolgreich gesendet!",
  "dashboard.failed_msg": "Nachricht konnte nicht gesendet werden",
  "dashboard.new_chat_message": "Neue Chat-Nachricht",
  "dashboard.user_msg": "Es gibt innerhalb der letzten 24 Stunden eine Benutzernachricht. Sie können mit jeder Nachricht antworten. Möchten Sie diese Vorlagenachricht trotzdem senden oder mit einer anderen Nachricht antworten?",
  "dashboard.us_number": "WhatsApp-Business-Nachrichten werden nicht an US-Nummern gesendet, da Meta am 1. April 2025 alle Marketingnachrichten an US-Nummern pausiert hat.",
  "dashboard.error_msg": "Bitte füllen Sie alle Platzhalter korrekt aus.",



  'web-widget.title': 'Web-Widget-Menüs für den Website-Chatbot',
  /* Home Page */
  'dashboards.quickstartwithai': 'Schnellstart mit KI',
  'dashboards.fastestpathtoautomation': 'Sie sind auf dem schnellsten Weg zur Automatisierung mit KI‑Tools',
  'dashboards.insightsthatempower': 'Erkenntnisse, die befähigen',
  'dashboards.trainchatbot': 'Chatbot trainieren',
  'dashboards.automatewithforms': 'Automatisierung mit Formularen',
  'dashboards.inroomdigitalcompendium': 'Digitales Verzeichnis im Raum',
  'dashboards.support': 'Support',
  'dashboards.helpcenter': 'Hilfezentrum',
  'dashboards.searchfaqintegrations': 'Suchen Sie nach Artikeln zu häufigen FAQs, Integrationen und mehr.',
  'dashboards.asklivechat': 'Stellen Sie unserem Team im Live‑Chat eine Frage',
  'dashboards.inroomqrcode': 'QR‑Code im Zimmer zur Anzeige von Informationen über Unterkunft und Lage',
  'dashboards.customizewebwidget': 'Passen Sie das Web‑Widget auf Ihrer Website an und fügen Sie einen integrierten KI‑Chatbot hinzu',
  'dashboards.createcustomforms': 'Erstellen Sie benutzerdefinierte Formulare und erhalten Sie Benachrichtigungen, wenn ein Gast ein Formular absendet',
  'dashboards.trainchatbotproperty': 'Trainieren Sie den Chatbot mit Informationen über Ihre Unterkunft wie Check‑in‑Zeit, Aktivitäten usw.',
  'dashboards.chatbotinsights': 'Sehen Sie, wie Ihr Chatbot mit Gästen interagiert, und erhalten Sie Einblicke in Statistiken wie Website‑Besucher, häufig gestellte Fragen und vieles mehr.',
  'dashboards.addaichatbottoyourwebsite': 'KI‑Chatbot zu Ihrer Website hinzufügen',


  /* 05.Pages */
  'pages.title.dashboards.analytics': 'Analytik',
  'pages.title.ari': 'Availability and Rates',
  'pages.title.conversations': 'Conversations',
  'pages.title.bookings': 'Reservierungen und Buchungen',
  'pages.title.tickets': 'Leads und Tickets',
  'pages.title.propinfo': 'Antworten',
  'pages.title.discounts': 'Rabatte und Aktionen',
  'pages.title.finance': 'Finanzen',
  'pages.title.integration': 'Integration',
  'pages.title.admin': 'Administratorin',
  'pages.add-new': 'NEUE HINZUFÜGEN',
  'pages.add-new-modal-title': 'Neues Element hinzufügen',
  'pages.display-options': 'Anzeigeoptionen',
  'pages.orderby': 'Sortieren nach : ',
  'pages.product-name': 'Produktname',
  'pages.category': 'Kategorie',
  'pages.description': 'Beschreibung',
  'pages.status': 'Status',
  'pages.cancel': 'Absagen',
  'pages.submit': 'Einreichen',
  'pages.delete': 'Löschen',
  'pages.another-action': 'Eine weitere Aktion',
  'pages.actions': 'AKTIONEN',
  'pages.header': 'Header',
  'pages.details': 'EINZELHEITEN',
  'pages.orders': 'AUFTRÄGE',
  'pages.rating': 'Bewertung',
  'pages.price': 'Preis',
  'pages.ingredients': 'Zutaten',
  'pages.is-vegan': 'Is Vegan',
  'pages.order-status': 'Order Status',
  'pages.bake-progress': 'Bake Progress',
  'pages.popularity': 'Popularity',
  'pages.comments': 'Comments',
  'pages.error-title': 'Ups... sieht aus, als wäre ein Fehler aufgetreten!',
  'pages.error-code': 'Fehlercode',
  'pages.go-back-home': 'WIEDER NACH HAUSE GEHEN',
  'pages.mailing-info':
    'Mailing-Vorlagen verwenden Inline-Styling und Tabellenlayout, um bei verschiedenen Dienstleistern gut angezeigt zu werden. Um eine bessere Benutzerfreundlichkeit zu bieten, fügen wir es als reguläres HTML mit DangerlySetInnerHTML ein.',
  'pages.invoice-info':
    'Die Rechnungsvorlage hat eine Inline-Version zur Verwendung außerhalb des Projekts sowie eine React-Version.',
  'pages.react-version': 'React Version',
  'pages.inline-version': 'Inline Styled Html Version',

  /* 06.Applications */

  /* 06.01.Chat */
  'chat.messages': 'Mitteilungen',
  'chat.contacts': 'Kontakte',
  'chat.saysomething': 'Sag etwas..',

  /* 06.02.Survey */
  'survey.delete': 'Löschen',
  'survey.edit': 'Bearbeiten',
  'survey.add-new': 'NEUE HINZUFÜGEN',
  'survey.add-new-title': 'Neue Umfrage hinzufügen',
  'survey.title': 'Titel',
  'survey.category': 'Kategorie',
  'survey.label': 'Etikett',
  'survey.status': 'Status',
  'survey.cancel': 'Absagen',
  'survey.submit': 'Einreichen',
  'survey.another-action': 'Eine weitere Aktion',
  'survey.display-options': 'Anzeigeoptionen',
  'survey.orderby': 'Sortieren nach : ',
  'survey.all-surveys': 'Alle Umfragen',
  'survey.completed-surveys': 'Abgeschlossene Umfragen',
  'survey.categories': 'Kategorien',
  'survey.active-surveys': 'Aktive Umfragen',
  'survey.labels': 'Etiketten',

  /* 06.03.Todo */
  'todo.add-new': 'NEUE HINZUFÜGEN',
  'todo.add-new-title': 'Neues Todo hinzufügen',
  'todo.title': 'Titel',
  'todo.detail': 'Einzelheit',
  'todo.category': 'Kategorie',
  'todo.label': 'Etikett',
  'todo.status': 'Status',
  'todo.cancel': 'Absagen',
  'todo.submit': 'Einreichen',
  'todo.action': 'Aktion',
  'todo.another-action': 'Eine weitere Aktion',
  'todo.display-options': 'Anzeigeoptionen',
  'todo.orderby': 'Sortieren nach : ',
  'todo.all-tasks': 'Alle Aufgaben',
  'todo.pending-tasks': 'Ausstehende Aufgaben',
  'todo.completed-tasks': 'Abgeschlossene Aufgaben',
  'todo.categories': 'Kategorien',
  'todo.labels': 'Etiketten',

  /* 07.UI */

  /* 07.01.Alerts */
  'alert.rounded': 'Abgerundete Warnung',
  'alert.react-notifications': 'React‑Benachrichtigungen',
  'alert.outline': 'Rahmen',
  'alert.primary': 'Primär',
  'alert.secondary': 'Sekundär',
  'alert.info': 'Info',
  'alert.success': 'Erfolg',
  'alert.warning': 'Warnung',
  'alert.error': 'Fehler',
  'alert.filled': 'Gefüllt',
  'alert.primary-text': 'Dies ist eine primäre Warnung – schau dir das an!',
  'alert.secondary-text': 'Dies ist eine sekundäre Warnung – schau dir das an!',
  'alert.success-text': 'Dies ist eine Erfolgswarnung – schau dir das an!',
  'alert.danger-text': 'Dies ist eine Gefahrenwarnung – schau dir das an!',
  'alert.warning-text': 'Dies ist eine Warnmeldung – schau dir das an!',
  'alert.info-text': 'Dies ist eine Info‑Warnung – schau dir das an!',
  'alert.light-text': 'Dies ist eine helle Warnung – schau dir das an!',
  'alert.dark-text': 'Dies ist eine dunkle Warnung – schau dir das an!',
  'alert.default': 'Standardwarnung',
  'alert.dismissing': 'Schließbare Warnung',
  'alert.dismissing-text': 'Heilige Guacamole! Du solltest einige der Felder unten überprüfen.',
  'alert.dismissing-without-animate-text': 'Ich bin eine Warnung und kann ohne Animation geschlossen werden!',


  /* 07.02.Badges */
  'badge.sizes': 'Größen',
  'badge.colors': 'Farben',
  'badge.outline': 'Rahmen',
  'badge.links': 'Links',
  'badge.counter-badges': 'Zähler‑Abzeichen',
  'badge.bootstrap-default': 'Bootstrap‑Standard',
  'badge.primary': 'Primär',
  'badge.secondary': 'Sekundär',
  'badge.success': 'Erfolg',
  'badge.danger': 'Gefahr',
  'badge.warning': 'Warnung',
  'badge.info': 'Info',
  'badge.light': 'Hell',
  'badge.dark': 'Dunkel',


  /* 07.03.Buttons */
  'button.default': 'Bootstrap‑Standard',
  'button.colors': 'Farben',
  'button.rounded': 'Abgerundet',
  'button.outline': 'Rahmen',
  'button.states': 'Zustände',
  'button.sizes': 'Größen',
  'button.button-groups': 'Schaltflächengruppen',
  'button.large-button': 'Große Schaltfläche',
  'button.small-button': 'Kleine Schaltfläche',
  'button.extra-small-button': 'Sehr kleine Schaltfläche',
  'button.block-button': 'Blockschaltfläche',
  'button.active': 'Aktiv',
  'button.disabled': 'Deaktiviert',
  'button.basic': 'Basis',
  'button.toolbar': 'Werkzeugleiste',
  'button.nesting': 'Verschachtelung',
  'button.vertical-variation': 'Vertikale Variation',
  'button.checkbox-radio-button': 'Checkbox und Radio Button',
  'button.checkbox': 'Checkbox',
  'button.radio': 'Radio',
  'button.radio-button': 'Radio Button',
  'button.primary': 'Primär',
  'button.secondary': 'Sekundär',
  'button.success': 'Erfolg',
  'button.danger': 'Gefahr',
  'button.warning': 'Warnung',
  'button.info': 'Info',
  'button.light': 'Hell',
  'button.dark': 'Dunkel',
  'button.states-text': 'Diese Schaltfläche zeigt 2 Sekunden lang einen Spinner und 3 Sekunden lang ein Fehler‑Icon, bevor sie wieder normal ist. Zustände lassen sich durch Hinzufügen oder Entfernen von Klassen auslösen.',
  'button.click-here': 'Hier klicken',
  'button.states-text-alternate': 'Diese Schaltfläche zeigt 2 Sekunden lang einen Spinner und 3 Sekunden lang ein Fehler‑Icon, bevor sie wieder normal ist. Zustände lassen sich durch Hinzufügen oder Entfernen von Klassen auslösen.',
  'button.primary-link': 'Primärer Link',
  'button.link': 'Link',
  'button.primary-button': 'Primäre Schaltfläche',
  'button.button': 'Schaltfläche',
  'button.left': 'Links',
  'button.middle': 'Mitte',
  'button.right': 'Rechts',
  'button.dropdown': 'Dropdown',
  'button.dropdown-link': 'Dropdown‑Link',


  /* 07.04.Cards */
  'cards.icon-card': 'Symbol‑Karte',
  'cards.image-card': 'Bilderkarte',
  'cards.image-overlay-card': 'Bild‑Overlay‑Karte',
  'cards.image-card-list': 'Bild‑Kartenliste',
  'cards.tab-card': 'Tab‑Karte',
  'cards.user-card': 'Benutzerkarte',


  /* 07.05.Carousel */
  'carousel.basic': 'Basis‑Karussell',
  'carousel.single': 'Einzelkarussell',
  'carousel.without-controls': 'Karussell ohne Steuerung',


  /* 07.06.Charts */
  'charts.line': 'Liniendiagramm',
  'charts.polar': 'Polardiagramm',
  'charts.area': 'Flächendiagramm',
  'charts.scatter': 'Streudiagramm',
  'charts.bar': 'Balkendiagramm',
  'charts.radar': 'Radardiagramm',
  'charts.pie': 'Kreisdiagramm',
  'charts.doughnut': 'Donutdiagramm',
  'charts.shadow': 'Schatten',
  'charts.no-shadow': 'Kein Schatten',


  /* 07.07.Collapse */
  'collapse.basic': 'Basis',
  'collapse.toggle': 'Umschalten',
  'collapse.accordion': 'Akkordeon',
  'collapse.controlled': 'Gesteuert',
  'collapse.uncontrolled': 'Ungesteuert',


  /* 07.08.Dropdowns */
  'dropdowns.basic': 'Basis',
  'dropdowns.controlled': 'Gesteuert',
  'dropdowns.uncontrolled': 'Ungesteuert',
  'dropdowns.dropdown': 'Dropdown',
  'dropdowns.header': 'Kopf',
  'dropdowns.action': 'Aktion',
  'dropdowns.another-action': 'Weitere Aktion',
  'dropdowns.right': 'Rechts',
  'dropdowns.left': 'Links',
  'dropdowns.drop-directions': 'Drop‑Richtungen',
  'dropdowns.dropright': 'Rechts öffnen',
  'dropdowns.dropleft': 'Links öffnen',
  'dropdowns.small-button': 'Kleine Schaltfläche',
  'dropdowns.large-button': 'Große Schaltfläche',
  'dropdowns.sizing': 'Größenanpassung',
  'dropdowns.split-button': 'Geteilte Schaltfläche mit Dropdown',
  'dropdowns.dropup': 'Hochklappen',


  /* 07.09.Editors */
  'editors.draftjs': 'Draft.js',
  'editors.quill-standart': 'Quill Standard',
  'editors.quill-bubble': 'Quill Bubble',


  /* 07.10.Forms */
  'forms.basic': 'Basis',
  'forms.email': 'E‑Mail',
  'forms.email-muted': 'Wir geben Ihre E‑Mail niemals weiter.',
  'forms.password': 'Passwort',
  'forms.submit': 'Einreichen',
  'forms.horizontal': 'Horizontal',
  'forms.radios': 'Radios',
  'forms.first-radio': 'Erstes Radio',
  'forms.second-radio': 'Zweites Radio',
  'forms.third-radio-disabled': 'Drittes Radio (deaktiviert)',
  'forms.checkbox': 'Checkbox',
  'forms.signin': 'Anmelden',
  'forms.top-labels-over-line': 'Obere Beschriftung über Linie',
  'forms.tags': 'Tags',
  'forms.date': 'Datum',
  'forms.state': 'Bundesland',
  'forms.top-labels-in-input': 'Obere Beschriftung im Eingabefeld',
  'forms.email-u': 'E‑MAIL',
  'forms.password-u': 'PASSWORT',
  'forms.tags-u': 'TAGS',
  'forms.date-u': 'DATUM',
  'forms.state-u': 'BUNDESLAND',
  'forms.grid': 'Formularraster',
  'forms.address': 'Adresse',
  'forms.address2': 'Adresse 2',
  'forms.city': 'Stadt',
  'forms.city-message': 'Bitte wählen Sie eine Stadt!',
  'forms.state-message': 'Bitte wählen Sie ein Bundesland!',
  'forms.zip': 'PLZ',
  'forms.signup': 'Registrieren',
  'forms.inline': 'Inline',
  'forms.validation-availity': 'Availity Reactstrap Validierung',
  'forms.validation-formik': 'Formik Validierung',
  'forms.default': 'Standard',
  'forms.firstname': 'Vorname',
  'forms.firstname-message': 'Bitte geben Sie Ihren Vornamen ein!',
  'forms.lastname': 'Nachname',
  'forms.lastname-message': 'Bitte geben Sie Ihren Nachnamen ein!',

  /* 07.11.Form Components */
  /* 07.11.Form Components */
  'form-components.custom-inputs': 'Benutzerdefinierte Eingaben',
  'form-components.checkboxes': 'Kontrollkästchen',
  'form-components.radios': 'Radio-Buttons',
  'form-components.inline': 'Inline',
  'form-components.react-select': 'React Select',
  'form-components.state-single': 'Einzelner Status',
  'form-components.state-multiple': 'Mehrfacher Status',
  'form-components.react-autosuggest': 'React Autosuggest',
  'form-components.date-picker': 'Datumsauswahl',
  'form-components.date': 'Datum',
  'form-components.date-range': 'Datumsbereich',
  'form-components.date-with-time': 'Datum mit Uhrzeit',
  'form-components.embedded': 'Eingebettet',
  'form-components.dropzone': 'Dropzone',
  'form-components.drop-files-here': 'Dateien hier ablegen',
  'form-components.tags': 'Tags',
  'form-components.switch': 'Schalter',
  'form-components.primary': 'Primär',
  'form-components.secondary': 'Sekundär',
  'form-components.primary-inverse': 'Primär invertiert',
  'form-components.secondary-inverse': 'Sekundär invertiert',
  'form-components.slider': 'Schieberegler',
  'form-components.double-slider': 'Doppelter Schieberegler',
  'form-components.single-slider': 'Einzelner Schieberegler',
  'form-components.rating': 'Bewertung',
  'form-components.interactive': 'Interaktiv',
  'form-components.readonly': 'Nur lesen',
  'form-components.type-a-cake': 'Gib einen Kuchen ein',
  'form-components.start': 'Start',
  'form-components.end': 'Ende',
  'form-components.tables': 'Tabellen',

  /* 07.12.Icons */
  'icons.simplelineicons': 'Simple Line Icons',
  'icons.iconsmind': 'Iconsmind Icons',

  /* 07.13.Input Groups */
  'input-groups.basic': 'Basis',
  'input-groups.sizing': 'Größenanpassung',
  'input-groups.small': 'Klein',
  'input-groups.default': 'Standard',
  'input-groups.large': 'Groß',
  'input-groups.checkboxes-and-radios': 'Kontrollkästchen und Radio-Buttons',
  'input-groups.multiple-inputs': 'Mehrere Eingaben',
  'input-groups.first-and-last-name': 'Vor- und Nachname',
  'input-groups.multiple-addons': 'Mehrere Add-ons',
  'input-groups.button-addons': 'Schaltflächen-Add-ons',
  'input-groups.button': 'Schaltfläche',
  'input-groups.buttons-with-dropdowns': 'Schaltflächen mit Dropdowns',
  'input-groups.dropdown': 'Dropdown',
  'input-groups.header': 'Kopf',
  'input-groups.action': 'Aktion',
  'input-groups.another-action': 'Eine weitere Aktion',
  'input-groups.custom-select': 'Benutzerdefinierte Auswahl',
  'input-groups.options': 'Optionen',
  'input-groups.choose': 'Wählen...',
  'input-groups.custom-file-input': 'Benutzerdefinierte Dateieingabe',

  /* 07.14.Jumbotron */
  'jumbotron.hello-world': 'Hallo Welt!',
  'jumbotron.lead':
    'Dies ist eine einfache Heldeneinheit, eine einfache Komponente im Jumbotron-Stil, um besondere Aufmerksamkeit auf bestimmte Inhalte oder Informationen zu lenken.',
  'jumbotron.lead-detail':
    'Es verwendet Hilfsklassen für Typografie und Abstände, um Inhalte innerhalb des größeren Containers zu verteilen.',
  'jumbotron.learn-more': 'Mehr erfahren',

  /* 07.15.Modal */
  'modal.basic': 'Basic',
  'modal.modal-title': 'Modaler Titel',
  'modal.launch-demo-modal': 'Demo-Modal starten',
  'modal.scrolling-long-content': 'Scrollen von langem Inhalt',
  'modal.backdrop': 'Hintergrund',
  'modal.backdrop-value': 'Hintergrundwert',
  'modal.right-modal': 'Rechtes Modal',
  'modal.launch-right-modal': 'Starten Sie Right Modal',
  'modal.nested-modal': 'Verschachteltes Modal',
  'modal.size': 'Größe',
  'modal.launch-large-modal': 'Starten Sie Large Modal',
  'modal.launch-small-modal': 'Starten Sie Small Modal',

  /* 07.16.Navigation */
  'nav.basic': 'Navi Basic',
  'nav.active': 'Aktiv',
  'nav.disabled': 'Deaktiviert',
  'nav.disabled-link': 'Link deaktiviert',
  'nav.link': 'Verknüpfung',
  'nav.longer-link': 'Länger Nav Verknüpfung',
  'nav.another-link': 'Ein weiterer Link',
  'nav.right': 'Recht',
  'nav.dropdown': 'Dropdown',
  'nav.header': 'Kopfzeilen',
  'nav.action': 'Aktion',
  'nav.another-action': 'Eine weitere Aktion',
  'nav.horizontal-alignment': 'Nav Horizontale Ausrichtung',
  'nav.vertical-alignment': 'Nav Vertikale Ausrichtung',
  'nav.pills': 'Nav Pillen',
  'nav.fill-justify': 'Nav Füllen und Rechtfertigen',
  'nav.pills-dropdowns': ' Nav Pillen mit Dropdowns',
  'nav.pagination-basic': 'Grundlegende Paginierung',
  'nav.pagination-sizing': 'Paginierungsgröße',
  'nav.large': 'Groß',
  'nav.small': 'Klein',
  'nav.center': 'Center',
  'nav.pagination-alignment': 'Paginierungsausrichtung',
  'nav.breadcrumb-basic': 'Brotkrümel Basic',

  /* 07.17.Popover & Tooltip */
  'popover-tooltip.popover': 'Popover',
  'popover-tooltip.tooltip': 'Kurzinfo',

  /* 07.18.Sortable */
  'sortable.columns': 'Spalten sortieren',
  'sortable.basic': 'Basic',
  'sortable.handles': 'Griffe',

  /* 07.19.Maps */
  'maps.google': 'Google',
  'maps.yandex': 'Jandex',

  /* 07.20.Tables */
  'table.bootstrap-tables': 'Bootstrap-Tabellen',
  'table.bootstrap-basic': 'Grundlegende Tabelle',
  'table.bootstrap-striped': 'Gestreift Reihen',
  'table.bootstrap-bordered': 'Eingefasster Tisch',
  'table.bootstrap-borderless': 'Randloser Tisch',
  'table.bootstrap-hoverable': 'Schwebefähig Reihen',
  'table.bootstrap-responsive': 'Responsive Tabelle',
  'table.react-tables': 'Reaktionstabellen',
  'table.react-pagination': 'Seitennummerierung',
  'table.react-scrollable': 'Scrollbar',
  'table.react-advanced': 'Filter, Länge und Springen',

  /* Property Info */
  "property-info.allcustomers": 'Alle Kunden',
  'property-info.external-sources': 'Externe Quellen',
  'property-info.faq': 'Häufig gestellte Fragen',
  'property-info.documents': 'Dokumente',
  'property-info.publish-ai': 'KI Veröffentlichen',
  'property-info.pre-built-templates': 'Vorgefertigte Vorlagen',
  'property-info.room-types': 'Zimmertypen',

  'property-info.about-property': 'Über Eigentum',
  'property-info.about-properties': 'Über Eigenschaften',
  'property-info.facilities-services': 'Einrichtungen & Dienstleistungen',
  'property-info.property-facilities': 'Eigentum Einrichtungen',
  'property-info.room-amenities': 'Zimmer Ausstattung',
  'property-info.property-contact': 'Eigentum Kontakt',
  'property-info.property-activities': 'Eigentum Aktivitäten',
  'property-info.property-location': 'Eigentum Ort',
  'property-info.about-rooms': 'Über Räume',
  'property-info.about-sites': 'Über Websites',
  'property-info.special-emergencies': 'Notfälle',
  'property-info.gallery': 'Galerie',
  'property-info.policies': 'Richtlinien',
  'property-info.nearby': 'In der Nähe',
  'property-info.transport': 'Transport',
  'property-info.location': 'Ort',
  'property-info.about-rhproperty': 'Um Ruhestand Heim',
  'property-info.related-topics': 'Verwandt Themen',
  'property-info.assistant-options': 'Assistentenmenü',
  'property-info.restaurant-assistant-information': 'Restaurantinformationen',
  'property-info.restaurant-assistant-options': 'Willkommensnachricht',
  'property-info.channel-messages': 'Kanalnachrichten',
  'property-info.icon.gallery': 'Icon-Galerie',
  'property-info.copilot': 'Kopilot',
  'property-info.sprint': 'Sprint',
  'property-info.home-information': 'Home-Informationen',
  'property-info.loction': 'Standorte',
  'property-info.rooms-and-images': 'Räume & Bilder',
  'property-info.trainig-data': 'Trainingsdaten',
  'property-info.flows': 'Fließt',
  'property-info.add-your-own': 'Füge dein eigenes hinzu',
  'property-info-utility-miscellaneous': 'Verschiedenes',
  'property-info-utility-payment': 'Zahlungen',
  'property-info-utility-broadband': 'Breitband',
  'property-info-utility-emergency': 'Notfall',
  'property-info-utility-mobile': 'Handy, Mobiltelefon',
  'property-info-utility-moving': 'Ziehen um',
  'property-info.publishMonitor': 'Veröffentlichen & Überwachen',
  'property-info.webWidget': 'Web-Widget',
  'property-info.media': 'Medien',
  /** Rate & Promo */
  'rate-promo.rate-plans': 'Tarifpläne',
  'rate-promo.rate-plan-addons': 'Add-Ons',
  'rate-promo.rate-plan-promos': 'Sonderangebote',

  'title.property-information': 'Eigentum Information',

  'property.message': 'Nachricht',
  'property.example': 'Beispiel',
  'property.link': 'Verknüpfungen',
  'property.image-carousel': 'Bildkarussell',
  'property.Title': 'Titel',
  'property.SubTitle': 'Untertitel',

  'property.add-invoke-api': 'API aufrufen',
  'property.add-message-button': 'Hinzufügen Mitteilungen',
  'property.add-img-button': 'Hinzufügen Bilder',
  'property.add-link-button': 'Hinzufügen Verknüpfung',
  'property.add-herocard-button': 'Hinzufügen Heldenkarte',
  'property.add-api-button': 'Hinzufügen Tasten',

  'menu.settings': 'Einstellungen',
  'menu.workflows': 'Arbeitsabläufe',
  'menu.product_services': 'Produkte und Dienstleistungen',
  'menu.product_recommander': 'Produktempfehlung',
  'menu.digital_guide_book': 'Digitaler Reiseführer',
  'menu.welcome_message': 'Begrüßungsnachricht',
  'menu.about-property': 'Über die Unterkunft',
  'menu.property-facilities': 'Ausstattung der Unterkunft',
  'menu.room-amenities': 'Zimmerausstattung',
  'menu.property-contact': 'Kontakt zur Unterkunft',
  'menu.about-rooms': 'Zimmer',
  'menu.special-emergencies': 'Notfälle',
  'menu.show-filter': 'Filter anzeigen',
  'menu.new': 'Neu',
  'menu.channel': 'Kanäle',
  'menu.application': 'Anwendungen',

  'dashboards.send': 'Senden',
  'dashboards.hello': 'Hallo',
  'dashboards.notificationsAllowed': 'Benachrichtigungen erlaubt',
  'dashboards.allowNotifications': 'Benachrichtigungen zulassen',
  'dashboards.views': 'Ansichten',
  'dashboards.bookingURL': 'Buchungs-URL',
  'dashboards.searchTags': 'Such-Tags',
  'dashboards.searchCategoryTags': 'Kategorie-Tags durchsuchen',
  'dashboards.bedroom': 'Schlafzimmer',
  'dashboards.addBedroom': 'Schlafzimmer hinzufügen',
  'dashboards.frequency': 'Häufigkeit',
  'dashboards.includeSubpages': 'Unterseiten einbeziehen',
  'dashboards.enableFaqs': 'FAQs aktivieren',
  'dashboards.faqsDescription': 'Durch Aktivierung der FAQs können Sie Fragen eingeben, während das System entsprechende Antworten aus dem Inhalt der Webseite extrahiert, um vollständige FAQs zu erstellen',
  'dashboards.faq': 'FAQ',
  'dashboards.deleteDocument': 'Dokument löschen',
  'dashboards.confirmDelete': 'Sind Sie sicher, dass Sie löschen möchten?',
  'dashboards.addItem': 'Element hinzufügen',
  'dashboards.addFirstWebPage': 'Ihre erste Webseite hinzufügen',

  'dashboards.popular-compendium': 'Beliebte Kompendium-Menüpunkte',
  'dashboards.wordcloudofcompendium': 'Wortwolke der Kompendium-Menüpunkte',
  'dashboards.wordcloudonthings': 'Wortwolke zu Fragen der Website-Besucher und Menüpunkten',
  'dashboards.common-asked': 'Häufig gestellte Fragen',
  'dashboards.website-visitor-asking':
    'Dinge, nach denen Website-Besucher fragen',
  'dashboards.visit-country': 'Website-Besuch nach Land',
  'dashboards.visit-traffic': 'Land des Website-Verkehrs',
  'dashboards.rooms-product': 'Zimmer & Produkte',
  'dashboards.popular-room-product': 'Beliebte Zimmer und Produkte',

  'dashboards.messenger-stats': 'Beliebte Menüpunkte',
  'dashboards.messenger-stats-topic-view':
    'Statistiken zu Menüelementansichten',
  'dashboards.messenger-stats-visits': 'Menüpunktansichten',
  'dashboards.opening-menu-items':
    'Anzahl der Website-Besucher, die Menüelemente öffnen',
  'dashboards.tickets-by-category': 'Tickets nach Kategorie',
  'dashboards.download': 'Herunterladen',
  'dashboards.number-totalavatarclick': 'Gesamtzahl der Avatar-Klicks',
  'dashboards.subscribe-to-reports': 'Abonniere Berichte',
  'dashboards.clicks': 'Klicks',
  'dashboards.leads': 'Führt',
  'dashboards.hours': 'Std',
  'dashboards.minutes': 'Protokoll',

  'dashboards.ai-chatbot': 'KI-Chatbot',
  'dashboards.compendium': 'Kompendium',
  'dashboards.compendium-digital-usage': 'Nutzung des digitalen Kompendiums',
  'dashboards.compendium-unique-visits': 'QR-Code-Scans/Klicks',
  'dashboards.compendium-opening-menu-items':
    'Anzahl der angezeigten Menüpunkte',
  'dashboards.compendium-total-digital-clicks':
    'Gesamtanzahl der Menüelementaufrufe',
  'dashboards.compendium-total-qr-code': 'Gesamtzahl der QR-Code-Scans/Klicks',
  'dashboards.compendium-avg-menu-items': 'Durchschnittliche Menüelementaufrufe pro Scan',

  'property.delete': 'Löschen',
  'menu.userroles': 'Benutzer & Rollen',
  'menu.members': 'Mitglieder',
  'menu.guest-pass': 'Gästepass',
  'menu.ratebookings': 'Preise & Buchungen',
  'dashboards.engagement-time': 'Einsatzzeit des digitalen Assistenten',
  'dashboards.conversations-minutes':
    'Gesamtminuten und Gesprächsminuten über Nacht (19:00 bis 7:00 Uhr).',
  'dashboards.visitor-questions': 'Besucherfragen',
  'dashboards.recent-queries': 'Letzte Abfragen',
  'dashboards.visitor-saying':
    'Was Ihre Besucher dem digitalen Assistenten sagen',
  'dashboards.contacts-prechatform-leavemessage':
    'Gespeicherte Kontakte aus dem Pre-Chat-Formular und Nachricht hinterlassen',
  'menu.dashboards': 'Einblicke',
  'menu.ari': 'Verfügbarkeit & Preise',
  'menu.conversations': 'Gespräche',
  'menu.conversations.unified-inbox': 'Einheitlicher Posteingang',
  'menu.conversations.active': 'Aktive Chats',
  'menu.conversations.archives': 'Archiv',
  'menu.conversations.missed-responses': 'Verpasste Antworten',
  'menu.conversations.ticket': 'Tickets',
  'menu.conversations.reply-templates': 'Antwortvorlagen',
  'menu.bookings': 'Reservierungen & Buchungen',
  'menu.tickets': 'Führt & Eintrittskarten',
  'menu.propinfo': 'Wissen Nabe',
  'menu.rate-promos': 'Preise & Werbeaktionen',
  'menu.finance': 'Finanzen',
  'menu.integration': 'Verbinden',
  'menu.admin': 'Verwaltung & Sicherheit',
  'menu.favourites': 'Favoriten',
  'menu.recommender': 'Gesprächsfluss',
  'menu.assistant-setup': 'Assistenten-Setup',
  'menu.admin-insights': 'Admin-Einblicke',
  'menu.super-admin': 'Super Admin',
  'menu.groups': 'Gruppen',
  'menu.properties': 'Eigenschaften',
  'menu.service-provider': 'Dienstleister',
  'menu.spaces': 'Räume',
  'menu.availability': 'Verfügbarkeit',
  'menu.help': 'Hilfe',
  'menu.myAccounts': 'Meine Konten',
  'menu.guest-messaging': 'Gästekommunikation',
  'guest-messaging.settings': 'Einstellungen',
  'guest-messaging.outreach-setup': 'Reichweiteneinrichtung',
  'guest-messaging.reservations': 'Reservierungen',
  'guest-messaging.insights_logs': 'Analysen und Protokolle',
  'guest-messaging.placeholder': 'Das Gästekommunikationsmodul folgt in Kürze.',
  'guest-messaging.settings.placeholder': 'Konfigurieren Sie Ihre Gästekommunikationseinstellungen.',
  'guest-messaging.outreach.placeholder': 'Richten Sie Reichweitenkampagnen und Vorlagen ein.',
  'guest-messaging.reservations.placeholder': 'Verwalten Sie reservierungsbezogene Nachrichten.',
  'guest-messaging.reservation-source': 'Reservierungsdatenquelle',
  'guest-messaging.communication-channels': 'Kommunikationskanäle',
  'guest-messaging.templates': 'Vorlagen',
  'guest-messaging.link': 'Link',
  'guest-messaging.business-profile': 'Geschäftsprofil',

  'dashboards.space-booking': 'Raumbuchung',
  'dashboards.gift-voucher': 'Geschenkgutscheine',
  'dashboards.chatbots': 'Chatbots',
  'dashboards.form': 'Aus',
  'dashboards.to': 'Zu',
  'dashboards.active-groups': 'Aktive Gruppen',
  'dashboards.active-properties': 'Aktive Eigenschaften',
  'dashboards.live-properties': 'Live-Eigenschaften',
  'dashboards.properties-going':
    'Eigenschaften, die nach Datumsbereich live gehen',
  'dashboards.start-date': 'Startdatum',
  'dashboards.end-date': 'Enddatum',

  'dashboards.website-visits': 'Webseite Besuche',
  'dashboards.unique-visitors': 'Einzigartig Besucher',
  'dashboards.last-week': 'Letzte Woche',
  'dashboards.this-week': 'In dieser Woche',
  'dashboards.this-month': 'Diesen Monat',
  'dashboards.previous-month': 'Vorheriger Monat',
  'dashboards.yeartodate': 'Der bisherige Jahresverlauf',
  'dashboards.lastyear': 'Letzte Jahr',
  'dashboards.last-7-days': 'Letzte 7 Tage',
  'dashboards.last-30-days': 'Letzte 30 Tage',
  'dashboards.last-60-days': 'Letzte 60 Tage',
  'dashboards.last-90-days': 'Letzte 90 Tage',
  'dashboards.conversion-rates': 'Umrechnungskurse',
  'dashboards.digital-assistant-engagement':
    'Engagement für digitale Assistenten',
  'dashboards.total-overnight-conversations':
    'Gesamt- und Übernachtungsgespräche (19:00 bis 7:00 Uhr).',
  'dashboards.percentage-accuracy': 'Wissensabdeckung',
  'dashboards.percentage-conversion': 'Umwandlung von Website-Traffic in Chat',
  'dashboards.percentage-avatarclick': 'Website-Traffic zu Avatar-Klicks',
  'dashboards.percentage-negativefeedback':
    'Negatives Feedback als Prozentsatz der Avatar-Klicks',
  'dashboards.percentage-amenties': 'Annehmlichkeit Abfragen',
  'dashboards.percentage-booking': 'Buchung Anfragen',
  'dashboards.percentage-webchats': 'Website-Chats',
  'dashboards.percentage-facebookchat': 'Facebook-Chats',
  // 'dashboards.number-webchattime': 'Total Web Chat Time',
  'dashboards.number-webchattime': 'Gesamt Gespräch Zeit',
  'dashboards.number-totalconversation': 'Totale Gespräche',
  'dashboards.number-websiteconversation': 'Website-Gespräche',
  'dashboards.number-facebookconversation': 'Facebook-Gespräche',
  'dashboards.number-estimatedtimesaving': 'Geschätzt Zeit Ersparnisse',
  'dashboards.number-googlemapsconversation': 'Google Maps Gespräche',
  'dashboards.number-whatsappconversation': 'WhatsApp-Gespräche',
  'dashboards.number-instagramconversation': 'Instagram-Gespräche',
  'dashboards.number-agentconversation': 'Agent Gespräche',
  'dashboards.number-amenityqueries': 'Annehmlichkeit Abfragen',
  'dashboards.number-bookingenquiries': 'Buchung Abfragen',
  'dashboards.number-groupbookingenquiries': 'Gruppe Buchung Anfragen',
  'dashboards.number-eventenquiries': 'Vorfall Anfragen',
  'dashboards.number-longstayenquiries': 'Lang Bleibe Anfragen',
  'dashboards.number-totaltickets': 'Eintrittskarten',
  'dashboards.number-returncustomer': 'Zurückkehren Kunde',
  'dashboards.number-redirects': 'Webseite Weiterleitungen',
  'dashboards.number-bookingengineleads': 'Buchungsmaschinen-Leads',
  'dashboards.number-roomnightsreferred': 'Übernachtungen bezogen',
  'dashboards.number-revenuereferred': 'Einnahmen bezogen',
  'menu.bookingsmenu': 'Buchungen',
  'menu.guests': 'Gäste Information',
  'menu.whatsnew': "Was gibt's Neues",
  'forms.forms-title': 'Form',
  'menu.formbuilder': 'Formularersteller',
  "dashboards.trainAI": "KI mit Dokumenten trainieren",
  "dashboards.uploadDocuments": "Laden Sie Dokumente hoch, damit Ihre KI Ihr Unternehmen kennenlernen und Kunden so unterstützen kann, wie Sie es tun würden. Sie können Dateien im Format .doc, .pdf oder .txt hinzufügen.",
  'dashboards.welcomeMessage': 'Begrüßungsnachricht',
  'dashboards.personalizeGreeting': 'Personalisieren Sie die Begrüßung Ihrer Kunden, um Ihre Marke, Ihren Stil und Ihre Etikette widerzuspiegeln und ihnen den herzlichsten Empfang zu bereiten. Passen Sie Begrüßungen an, um Ihre Marke widerzuspiegeln und eine warme Atmosphäre zu schaffen.',
  'dashboards.addRoomDetails': 'Fügen Sie Details zu jedem Ihrer Zimmer hinzu, damit Gäste leicht alles entdecken können, was sie benötigen, um die perfekte Wahl zu treffen, und machen Sie den Buchungsprozess einfacher und schneller.',
  'dashboards.trainAIFAQs': 'KI mit FAQs trainieren',
  'dashboards.manualQuestions': 'Manche Fragen können nicht durch Dokumente beantwortet oder auf der Website gefunden werden. Hier können Sie Fragen manuell hinzufügen, um sicherzustellen, dass Kunden immer die Informationen erhalten, die sie benötigen.',
  'dashboards.publishAI': 'Veröffentliche KI, um die neuesten Aktualisierungen widerzuspiegeln',
  'dashboards.retrainAfterChanges': 'Wenn Sie Änderungen im Knowledge Hub oder in Formularen vornehmen, stellen Sie sicher, dass Sie den Chatbot mit den aktualisierten Informationen neu trainieren. Durch das Veröffentlichen Ihrer KI stellen Sie sicher, dass der Chatbot die genauesten und aktuellsten Antworten liefert.',
  'dashboards.enhanceKnowledge': 'Erweitern Sie das KI-Wissen durch Verfolgung unbeantworteter Anfragen',
  'dashboards.reviewUnanswered': 'Immer wenn die KI eine Frage nicht beantworten kann oder nur begrenzte Details liefert, finden Sie diese Anfragen hier. Überprüfen Sie sie, um Lücken in Ihrem Knowledge Hub oder einzigartige Gästefragen zu identifizieren.',
  'dashboards.manageMedia': 'Medien verwalten',
  'dashboards.mediaGallery': 'Wenn Sie Bilder hochladen – etwa von Zimmern, Annehmlichkeiten, Logos oder Ihrem digitalen Avatar – werden sie in dieser Galerie angezeigt, sodass Sie einen zentralen Ort haben, um visuelle Inhalte zu verwalten und sicherzustellen, dass Ihre Gäste sehen, was Ihr Unternehmen einzigartig macht.',
  'dashboards.createForms': 'Erstellen Sie Formulare ganz einfach und erhalten Sie eine Benachrichtigung bei jeder Einreichung.',
  'dashboards.manageForms': 'Erstellen und verwalten Sie Formulare, um Kundeninformationen zu sammeln, Benachrichtigungen einzurichten und sie für verschiedene Sprachen anzupassen.',
  'dashboards.personalizeResponse': 'Personalisieren Sie den Antwortstil und wie sich das Gespräch entwickelt',
  'dashboards.controlConversation': 'Diese erweiterte Funktion gibt Ihnen die Möglichkeit, zu gestalten und zu kontrollieren, wie Gespräche mit Ihren Kunden über verschiedene Kanäle verlaufen.',

  'menu.virtualfrontdesk': 'Virtuelle Rezeption',
  'menu.guestservice': 'Dienstleistungen für die Gäste',
  'virtual-front.common-questions': 'Häufige Fragen',
  'virtual-front.add-on-upsells': 'Add-Ons und Upsells',
  'virtual-front.service-order': 'Serviceauftrag',
  // 'virtual-front.guest-service-add-on-upsells': "Gästeservices und Add-Ons",
  'virtual-front.guest-service-add-on-upsells': 'Digitales Gästebuch',
  'virtual-front.outbound': 'Ausgehend',
  'virtual-messenger': 'Botin',

  'missed-response.missed-response-title': 'Titel der verpassten Antwort',

  //unified-inbox 
  'content.allconversation': 'Alle Unterhaltungen',
  'content.active': 'Aktiv',
  'content.tickets': 'Tickets',
  'content.filter': 'Filtern',
  'content.createtickets': 'Tickets erstellen',
  'content.conversation': 'Unterhaltung',
  'content.knowledgesearch': 'Wissenssuche',
  'content.reply': 'Antworten',
  'content.visitorinfo': 'Besucherinformationen',
  'content.callinfo': 'Anrufinformationen',
  'content.allinsights': 'Alle Erkenntnisse',
  'content.availabilityrates': 'Verfügbarkeit & Preise',
  'content.callback': 'Rückruf',
  'content.close': 'Schließen',
  'content.sms': 'SMS',
  'content.timestamp': 'Zeitstempel',
  'content.topics': 'Themen',
  'content.callingparty': 'Anrufender Teilnehmer',
  'content.accountdomain': 'Kontodomain',
  'content.calledparty': 'Angerufene Partei',
  'content.recording': 'Aufzeichnung',
  'content.phonesystemoriginationcallid': 'Ursprungsanruf-ID des Telefonsystems',
  'content.phonesystemterminationcallid': 'Endanruf-ID des Telefonsystems',
  'content.uniqueconversationid': 'Eindeutige Unterhaltungs-ID',
  'content.regenerateinsights': 'Erkenntnisse neu generieren',
  'content.customersentiment': 'Kundenzufriedenheit',
  'content.neutral': 'Neutral',
  'content.customerreportedbroadbandoutage': 'Kunde meldete eine Breitbandstörung und gab seine Kunden-ID sowie das Aktivierungsdatum des Dienstes an, um Unterstützung zu erhalten.',
  'content.conversationinsights': 'Unterhaltungsanalysen',
  'content.broadbandoutage': 'Breitbandstörung',
  'content.customeridverification': 'Kunden-ID-Verifizierung',
  'content.serviceactivationdate': 'Dienstaktivierungsdatum',
  'content.followups': 'Nachverfolgungen',
  'content.actionneeded': 'Maßnahme erforderlich',
  'content.uniqueConversationId': 'Eindeutige Gesprächs ID',
  'content.uniqueChatId': 'Eindeutige Chat ID',
  'content.recording&transcript': 'Aufzeichnung & Transkript',
  'content.chatinsights': 'Chat‑Einblicke',
  'content.visitedpages': 'Besuchte Seiten',
  'content.deviceinfo': 'Geräteinformationen',
  'content.chatstartedonthispage': 'Chat auf dieser Seite begonnen',
  'content.prechatinfo': 'Vor‑Chat‑Informationen',
  'content.notes': 'Notizen',
  'content.reassign': 'Neu zuweisen',
  'content.open': 'Öffnen',
  "content.dismiss": "Schließen",
  "content.add_placeholder": "Platzhalterwerte hinzufügen",
  "content.mobile_number": "Mobilnummer",
  "content.please_select": "Bitte auswählen",
  'content.sendwhatsapp': 'WhatsApp-Nachricht senden',

  /* Missed Response */

  'feedback.missed-question': 'Verpasste Frage',
  'feedback.conversation-summary': 'Gesprächszusammenfassung',
  'feedback.dates-in-spanish': 'Daten müssen auf Spanisch sein',
  'feedback.resolve': 'Lösen',
  'feedback.ignore': 'Ignorieren',

  /*Integration */
  // de-DE
  'integration.select_properties': 'Eigenschaften auswählen',
  'integration.select_properties_enabled': 'Wählen Sie die über diese Integration aktivierten Eigenschaften',
  'integration.services_addons': 'Dienste & Add‑ons auswählen',
  'integration.services_visible': 'Wählen Sie aus, welche Dienste & Add‑ons auf dieser Seite sichtbar sind',
  'integration.appearance': 'Erscheinungsbild',
  'integration.appearance_customize': 'Wählen Sie den Namen Ihres digitalen Assistenten, Avatar und Farben',
  'integration.booking_calendar': 'Buchungskalender',
  'integration.booking_calendar_style': 'Wählen Sie das Styling für das Buchungskalender‑Pop‑up',
  'integration.nudges': 'Hinweise',
  'integration.nudges_setup': 'Richten Sie proaktive Nachrichten ein, um Website‑Besucher anzusprechen',
  'integration.position': 'Position',
  'integration.position_control': 'Steuern Sie die Position des Chat‑Widgets auf Ihrer Website',
  'integration.custom_fonts': 'Benutzerdefinierte Schriftarten',
  'integration.custom_fonts_upload': 'Laden Sie benutzerdefinierte Schriftarten hoch, die Sie auf der Seite verwenden möchten',
  'integration.custom_css': 'Benutzerdefiniertes CSS',
  'integration.custom_css_usage': 'Verwenden Sie CSS zur Anpassung Ihres Digitalen Kompendiums',
  'integration.location': 'Standort',
  'integration.location_embed': 'Fügen Sie Ihre Embed‑URL hinzu',
  'integration.external_links': 'Externe Links',
  'integration.external_links_add': 'Fügen Sie Ihre Links hinzu',
  'integration.language': 'Sprache',
  'integration.widget_languages': 'Wählen Sie Sprachen für das Chat‑Widget',
  'integration.chatbot_contact': 'Chatbot ',
  'integration.chatbot_enable': 'Aktivieren Sie Ihren digitalen Assistenten',
  'integration.chatbot_security': 'Halten Sie Ihren Messenger sicher',
  'integration.chatbot_trusted_pages': 'Listen Sie Ihre vertrauenswürdigen Seiten auf, um den Chatbot anzuzeigen',
  'integration.chatbot_publish': 'Veröffentlichen Sie Ihren digitalen Assistenten',
  'integration.chatbot_install': 'Kopieren Sie den Code‑Snippet, um Ihren digitalen Assistenten zu installieren',


};
export default deMessages;